import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "photo-picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_image_not_uploaded = _resolveComponent("app-image-not-uploaded")!
  const _component_app_image_color_picker = _resolveComponent("app-image-color-picker")!
  const _component_app_color_picker = _resolveComponent("app-color-picker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chroma-wrapper", { hiddenOverflow: _ctx.isHiddenOverflow }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.imgEl)
        ? (_openBlock(), _createBlock(_component_app_image_not_uploaded, {
            key: 0,
            onOnFileSelected: _ctx.onFileSelected
          }, null, 8, ["onOnFileSelected"]))
        : _createCommentVNode("", true),
      (_ctx.imgEl)
        ? (_openBlock(), _createBlock(_component_app_image_color_picker, {
            key: 1,
            "image-element": _ctx.imgEl,
            "is-show-section-info": false,
            onSelectedHex: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedHex = $event)),
            onIsHiddenOverflow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isHiddenOverflow = $event))
          }, null, 8, ["image-element"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_app_color_picker, {
      "is-info-btn": true,
      "hex-p": _ctx.selectedHex
    }, null, 8, ["hex-p"])
  ], 2))
}